import React from 'react'
import { Link } from 'react-router-dom';
const Community = () => {
  return (
    <div>
     <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec" style={{ background: "rgba(243, 240, 216, 1)" }}>
     
        <div class="container">
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="title-area text-center">
                        <span class="sub-title">Connect, Share & Learn with the Drone TV Community</span>
                        <p class="sec-text">Join our thriving community of drone enthusiasts, pilots, and professionals</p>
                    </div>
                    <div className="header-button" style={{justifyContent:"center"}}>
                     
                       <Link to="/community" className="th-btn">
                       Join WhatsApp Community
                       </Link>
                     </div>
                </div>
            </div>
            
        </div>

    </section>
     <footer class="footer-wrapper footer-layout1">
            <div class="widget-area">
                <div class="container">
                    <div class="newsletter-area">
                        <div class="newsletter-top">
                            <div class="row gy-4 align-items-center">
                                <div class="col-lg-5">
                                    <h2 class="newsletter-title text-capitalize mb-0">Subscribe to Drone TV</h2>
                                </div>
                                <div class="col-lg-7">
                                    <form class="newsletter-form">
                                        <input class="form-control " type="email" placeholder="Enter Email" required=""/>
                                        <button type="submit" class="th-btn style3">Subscribe Now <img src="assets/img/icon/plane.svg" style={{width:"50%", height:"50%"}} alt="/"/></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-between">
                        <div class="col-md-6 col-xl-3">
                            <div class="widget footer-widget">
                                <div class="th-widget-about">
                                    <div class="about-logo">
                                        <a href="home-travel.html"><img src="assets/img/hero/logo.jpg" alt="Tourm"/></a>
                                    </div>
                                  
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-xl-auto">
                            <div class="widget widget_nav_menu footer-widget">
                                <h3 class="widget_title">Quick Links</h3>
                                <div class="menu-all-pages-container">
                                    <ul class="menu">
    
                                    <li>
                            <Link to="/" className="active">Home</Link>
                          </li>
                          <li>
                            <Link to="/video">Videos</Link>
                          </li>
                          <li>
                            <Link to="/event">Events</Link>
                          </li>
                          <li>
                            <Link to="/community">Community</Link>
                          </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-xl-auto">
                            <div class="widget footer-widget">
                                <h3 class="widget_title">Address</h3>
                                <div class="th-widget-contact">
                                    <div class="info-box_text">
                                        <div class="icon">
                                            <img src="assets/img/icon/phone.svg" alt="img"/>
                                        </div>
                                        <div class="details">
                                            <p style={{marginTop:"12px"}}><a href="tel:+917520123555" class="info-box_link">+91 7520123555</a></p>
                                        </div>
                                    </div>
                                    <div class="info-box_text">
                                        <div class="icon">
                                            <img src="assets/img/icon/envelope.svg" alt="img"/>
                                        </div>
                                        <div class="details">
                                            <p style={{marginTop:"12px"}}><a href="mailto:info@dronetv.in" class="info-box_link">info@dronetv.in</a></p>
                                        </div>
                                    </div>
                                    <div class="info-box_text">
                                        <div class="icon"><img src="assets/img/icon/location-dot.svg" alt="img"/></div>
                                        <div class="details">
                                            <p style={{marginTop:"12px"}}> HICC, Hyderabad, India</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-xl-auto">
                            <div class="widget footer-widget">
                                <h3 class="widget_title">Social media</h3>
                                <div class="th-social">
                                        <a href="https://www.facebook.com/"><i class="fab fa-facebook-f"></i></a>
                                        <a href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a>
                                        <a href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a>
                                        <a href="https://www.whatsapp.com/"><i class="fab fa-whatsapp"></i></a>
                                        <a href="https://instagram.com/"><i class="fab fa-instagram"></i></a>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright-wrap" data-bg-src="assets/img/bg/copyright_bg_1.jpg">
                <div class="container">
                    <div class="row justify-content-between align-items-center" style={{textAlign:"center"}}>
                        <div class="col-md-6">
                            <p class="copyright-text">Copyright 2025 <a href="home-travel.html">AJS Innovations</a>. All Rights Reserved.</p>
                        </div>
                       
                    </div>
    
                </div>
            </div>
    
        </footer>
    </div>
  )
}

export default Community
